import React from 'react';
import {
  Box,
  Button,
  Typography,
  Link,
  useTheme,
  useMediaQuery,
  Grid,
} from '@mui/material';
import engineerImg from '../../Image/engineerImg.svg';

const PartnerProgram = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box pb={'2rem'} pt={'3rem'}>
      {isMobile ? (
        <>
          <Typography variant='subtitle1' fontWeight='600' pb={2}>
            Earn from solar?
          </Typography>
          <Typography variant='h4' fontWeight='bold' mt={1}>
            You refer, we close
          </Typography>
          <Typography variant='h6' mt={1}>
            We make a great team together
          </Typography>
          <Box
            component='img'
            src={engineerImg}
            alt='Engineer'
            sx={{ width: '100%', my: 2 }}
          />
          <Typography variant='body1'>Rewards</Typography>
          <Typography variant='h6' fontWeight='bold'>
            up to ₹50,000 per month
          </Typography>
          <Button
            variant='contained'
            sx={{
              marginTop: '2rem',
              borderRadius: '32px',
              backgroundColor: '#A8D5A8',
              color: '#000',
              width: '100%',
              '&:hover': {
                backgroundColor: '#91c291',
              },
            }}
            onClick={() => {
              window.location.href =
                'https://support.vaysolar.com/hc/en-us/requests/new?ticket_form_id=19380578868124';
            }}
          >
            SIGN UP
          </Button>
          <Typography
            variant='body2'
            mt={2}
            color={'black'}
            textAlign={'center'}
          >
            Have questions?{' '}
            <Link href='#' color={'black'} fontWeight='bold'>
              Contact us
            </Link>
          </Typography>
        </>
      ) : (
        <Grid container spacing={4} sx={{ py: 4 }}>
          <Grid
            item
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant='h3' fontWeight='bold'>
              Earn from solar
            </Typography>

            <Typography variant='h1' fontWeight='bold' mt={2}>
              You refer, we close
            </Typography>

            <Typography variant='h4' color='textSecondary' mb={16}>
               We make a great team together
            </Typography>

            <Typography variant='h3' mb={1}>
              Rewards
            </Typography>

            <Typography variant='h3' fontWeight='bold' mb={3}>
              up to ₹50,000 per month
            </Typography>

            <Button
              variant='contained'
              sx={{
                borderRadius: '32px',
                backgroundColor: '#A8D5A8',
                color: '#000',
                width: '10rem',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#91c291',
                },
              }}
              onClick={() => {
                window.location.href =
                  'https://support.vaysolar.com/hc/en-us/requests/new?ticket_form_id=19380578868124';
              }}
            >
              SIGN UP
            </Button>

            <Typography variant='body2' mt={2} color={'black'}>
              Have questions?{' '}
              <Link
                href='https://support.vaysolar.com/hc/en-us/requests/new?ticket_form_id=14570268863260'
                color={'black'}
                fontWeight='bold'
              >
                Contact us
              </Link>
            </Typography>
          </Grid>

          <Grid item md={6} sx={{ml: isMobile ? 0 : 'unset'}}>
            <Box
              component='img'
              src={engineerImg}
              alt='Engineer'
              sx={{
                width: '100%',
                maxWidth: '500px',
                display: 'block',
                margin: 'auto',
              }}
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default PartnerProgram;
